import {useMemo} from 'react';
import {useAppDispatch} from '../../../store/store';
import {matrixActions} from '../matrix/matrixActions';
import type {CallLeg} from '../model/types';
import {usePhoneActions} from '../phone/usePhoneActions';

export interface LegActions {
    readonly answer: (leg: CallLeg) => void;
    readonly decline: (leg: CallLeg) => void;
    readonly end: (leg: CallLeg) => void;
    readonly setHold: (leg: CallLeg, held: boolean) => void;
}

export const useLegActions = (): LegActions => {
    const dispatch = useAppDispatch();
    const phone = usePhoneActions();
    return useMemo(() => ({
        answer: leg => {
            if (leg.engine === 'sip') {
                phone.answer();
            } else if (leg.engine === 'matrix') {
                void matrixActions.answer(leg.matrixCallId, leg.kind === 'video', dispatch);
            }
        },
        decline: leg => {
            if (leg.engine === 'sip') {
                phone.decline();
            } else if (leg.engine === 'matrix') {
                void matrixActions.decline(leg.matrixCallId, dispatch);
            }
        },
        end: leg => {
            if (leg.engine === 'sip') {
                phone.end();
            } else if (leg.engine === 'matrix') {
                void matrixActions.end(leg.matrixCallId, dispatch);
            }
        },
        setHold: (leg, held) => {
            if (leg.held === held) {
                return;
            }
            if (leg.engine === 'sip') {
                phone.toggleHold();
            } else if (leg.engine === 'matrix') {
                matrixActions.setHold(held);
            }
        },
    }), [dispatch, phone]);
};
